<div mat-dialog-title class="w-100">
    <div
        class="title d-flex align-items-center justify-content-space-between pop-up-header head"
    >
        <h4 class="mb-0 pop-up-text">
          
        </h4>
        <button
            class="close-button"
            (click)="close()"
        >
            <i class="flaticon-close"></i>
        </button>
    </div>
</div>
<div class="body">
    <div class="header">
        <div>
            <img src="https://i.postimg.cc/VNqFhQfH/kingston-university.jpg" class="img-header">
        </div>
        <div class="left-header">
            Kingston International<br>
            T +44 (0)20 8417 9000<br>
            E internationaladmin{{this.emailComponent}}kingston.ac.uk<br>
            www.kingston.ac.uk/international
        </div>
        <div class="right-header">
            Yorkon Building<br>
            Kingston Hill Campus<br>
            Kingston upon Thames<br>
            KT2 7LB
        </div>
    </div>

    <!-- Title -->
    <div class="title">Agent Authorisation / Change of Agent Form</div>
    <div class="subtitle">
        For record keeping and agency tagging, this form must be completed, signed by the student and uploaded to OSIS<br>
        as part of the application or change request. Please direct all queries concerning this to:<br>
        admissionsops{{this.emailComponent}}kingston.ac.uk
    </div>

    <!-- Student Details -->
    <div class="section">
        <div class="section-title">Student Details</div>
        <div class="form-row">
            <div class="label">Kingston/UCAS ID:</div>
            <div class="field"></div>
        </div>
        <div class="form-row">
            <div class="label">Course Name:</div>
            <div class="field"><span>{{courseName}}</span></div>
        </div>
        <div class="form-row">
            <div class="label">Given Name(s):</div>
            <div class="field"><span>{{firstName}}</span></div>
        </div>
        <div class="form-row">
            <div class="label">Family Name:</div>
            <div class="field"><span>{{lastName}}</span></div>
        </div>
        <div class="form-row">
            <div class="label">Date of Birth:</div>
            <div class="field"><span>{{dateOfBirth}}</span></div>
        </div>
        <div class="form-row">
            <div class="label">Email:</div>
            <div class="field"><span>{{email}}</span></div>
        </div>
    </div>

    <!-- Current Agent Details -->
    <div class="section">
        <div class="section-title">Current Agent Details</div>
        <div class="form-row">
            <div class="label">Agent Name:</div>
            <div class="field"></div>
        </div>
        <div class="form-row">
            <div class="label">Agent Address:</div>
            <div class="field"></div>
        </div>
        <div class="form-row">
            <div class="label">Agent Email:</div>
            <div class="field"></div>
        </div>
        <div class="form-row">
            <div class="label">Office/Branch:</div>
            <div class="field"></div>
        </div>
        <div class="form-row">
            <div class="label">Country:</div>
            <div class="field"></div>
        </div>
    </div>

    <!-- New Agent Details -->
    <div class="section">
        <div class="section-title">New Agent Details (If changing agent)</div>
        <div class="form-row">
            <div class="label">Agent Name:</div>
            <div class="field"></div>
        </div>
        <div class="form-row">
            <div class="label">Agent Address:</div>
            <div class="field"></div>
        </div>
        <div class="form-row">
            <div class="label">Agent Email:</div>
            <div class="field"></div>
        </div>
        <div class="form-row">
            <div class="label">Office/Branch:</div>
            <div class="field"></div>
        </div>
        <div class="form-row">
            <div class="label">Country:</div>
            <div class="field"></div>
        </div>
    </div>

    <!-- Reason for Change -->
    <div class="section">
        <div>If you are changing your agent please indicate the reason why you are not satisfied with your current agent:</div>
        <div class="checkbox-row">
            <div class="checkbox-item">
                <div class="checkbox">&#9744;</div>
                <div>Not responsive to my requests</div>
            </div>
            <div class="checkbox-item">
                <div class="checkbox">&#9744;</div>
                <div>Provided wrong or misleading information</div>
            </div>
        </div>
        <div class="checkbox-item">
            <div class="checkbox">&#9744;</div>
            <div>Other (please explain):</div>
        </div>
        <div class="field" style="width: 100%; margin-top: 3px;"></div>
    </div>

    <!-- Student Declaration -->
    <div class="section">
        <div class="section-title">Student Declaration</div>
        <div class="declaration">
            I hereby confirm and authorise <span class="blank-line">{{fullName}}</span> to share my
            data with Kingston University and to act on my behalf in all matters relating to my application. Please
            can you inform them of any updates to my application status and keep them informed of any progress.
            <br><br>
            In accordance with the Data Protection Act (DPA) and General Data Protection Regulations (GDPR), I
            hereby give permission to the University to share any information regarding my application and
            supporting documents with this agent.
        </div>
        <div class="signature-row">
            <div class="signature-block d-flex">
                <div style="padding-top:7px">Student Signature:</div>
            </div>
            <div class="signature-block">
                <div style="padding-top:7px">Date: {{date}}</div>
            </div>
        </div>
    </div>

    <!-- Internal Use Only -->
    <div class="internal">
        <div class="internal-title">For Internal Use Only</div>
        <div class="internal-row">
            <div class="checkbox-item">
                <div class="checkbox">&#9744;</div>
                <div>Approved</div>
            </div>
            <div class="checkbox-item">
                <div class="checkbox">&#9744;</div>
                <div>Not Approved</div>
            </div>
            <div style="margin-left: 20px;">
                <span>Commission Allocation:</span>
                <span style="display: inline-block; width: 120px; border-bottom: 1px solid #000;"></span>
            </div>
        </div>
        <div class="signature-row">
            <div class="internal-block">
                <div>Name of IO/RM:</div>
                <div class="signature-line"></div>
            </div>
            <div class="internal-block">
                <div>Signature:</div>
                <div class="signature-line"></div>
            </div>
            <div class="internal-block">
                <div>Date:</div>
                <div class="signature-line"></div>
            </div>
        </div>
        <div class="button-container">
        <button class="submit-button" (click)="sendForSignature()">Send for signature</button>
    </div>
    </div>
</div>

